import { Button, Dialog, Input, Select, Icon, TextArea } from '@app/components';
import React from 'react';
import {
  CancelUpload,
  DocumentHeader,
  NoDataContainer,
  NotesContainer,
  SelectDocType,
  UploadFooter,
} from '@app/modules/transaction-form/documents-component';
import { useGetUploadDocTypes } from '@app/graphql';
import {
  CustomButtonContainer,
  SelectItem,
  SelectLabel,
  Seperator,
  Star,
  Title,
} from '@app/modules/transaction-form/transactions-form-components';
import { InputCard } from '../transaction-details/transactions-details-components';
import DocumentsUpload from './documents-upload';
import { SelectOption } from '@app/types/types';
import { s3BucketName, s3 } from '@app/providers/aws';
import UploadedDocuments from './uploaded-document';
import moment from 'moment';
import { DocErrorType, UploadDocType } from '@app/types/documents';
import { Label } from '@app/components/input/input-components';
type documentType = {
  label: string;
  value: string;
};
const defaultSelectOption = {
  label: 'Please Select',
  value: '',
};
type filesType = {
  getFiles: (filesData: any) => void;
  uploadedDocs?: any;
  afterRemove: any;
  fromEditPage?: boolean;
  firebaseId?: string;
  isApproved?: boolean;
  editTransactionPermission?: boolean;
};
export default function Documents({
  getFiles,
  uploadedDocs,
  afterRemove,
  fromEditPage,
  firebaseId,
  isApproved,
  editTransactionPermission,
}: filesType) {
  const s3ObjectUrl: string = process.env.REACT_APP_AWS_S3_OBJECT_URL || '';
  const styles: string =
    'color: #27323C;font-size: 24px;line-height:24px;margin-left:0px;';
  const [documentType, setDocumentType] = React.useState<SelectOption>(
    defaultSelectOption,
  );
  const [documentTypes, updateDocumentTypes] = React.useState<any>([]);
  const [showDocumentUpload, updateShowDocumentUpload] = React.useState(false);
  const [uploadText, updateUploadText] = React.useState('');
  const [otherDocument, updateOtherDocument] = React.useState(false);
  const [otherDocType, updateOtherDocType] = React.useState('');
  const [documents, updateDocuments] = React.useState<any>([]);
  const [uploadProgress, updateUploadProgress] = React.useState(0);
  const [documentNotes, updateDocumentNotes] = React.useState('');
  const [isSubmitted, updateIsubmitted] = React.useState(false);
  const [, updateErrorMessage] = React.useState('');
  const [uploadedDocData, updateUploadedDocData] = React.useState(uploadedDocs);
  const [isEdit, updateIsEdit] = React.useState(false);
  const [selectedFile, updateSelectedFile] = React.useState<any>([]);
  const [index, updateIndex] = React.useState(0);
  const [showError, updateShowError] = React.useState<DocErrorType>({
    show: false,
    message: '',
  });
  const { loading: docTypeLoading, data: docTypeData } = useGetUploadDocTypes();
  React.useEffect(() => {
    if (uploadedDocs && uploadedDocs.length) {
      updateUploadedDocData(uploadedDocs);
    }
  }, [uploadedDocs]);

  React.useEffect(() => {
    if (
      !docTypeLoading &&
      docTypeData &&
      docTypeData.getAllUploadDocType &&
      docTypeData.getAllUploadDocType.docTypes &&
      docTypeData.getAllUploadDocType.docTypes.length
    ) {
      const formatDocs: documentType = docTypeData.getAllUploadDocType.docTypes.map(
        (doc: any, key: number) => {
          return {
            value: doc.docType,
            label: doc.docType,
          };
        },
      );
      updateDocumentTypes(formatDocs);
    }
  }, [docTypeLoading, docTypeData]);

  const onChange = (event: any, type?: string) => {
    if (type === 'documentType') {
      if (event && event.value === 'Other') {
        updateOtherDocument(true);
      } else {
        updateOtherDocument(false);
      }
      setDocumentType(event);
    } else if (type === 'otherDoc') {
      updateShowError({ show: false, message: '' });
      updateOtherDocType(event.target.value);
    } else if (type === 'documentNotes') {
      updateDocumentNotes(event.target.value);
    }
  };

  function getRandomStr(len: number) {
    var p = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return [...Array(len)].reduce(a => a + p[~~(Math.random() * p.length)], '');
  }

  function removeDocument(
    docs?: UploadDocType[],
    removedDoc?: UploadDocType[],
  ) {
    updateUploadedDocData(docs);
    afterRemove(docs, removedDoc);
  }

  function afterUpload(percentage: number) {
    updateUploadText('Uploaded');
    setTimeout(() => {
      updateOtherDocument(false);
      updateShowDocumentUpload(false);
      setDocumentType(defaultSelectOption);
      updateIsubmitted(false);
      updateUploadText('');
      updateDocumentNotes('');
      updateSelectedFile(defaultSelectOption);
      updateIsEdit(false);
    }, 1000);
  }

  function setDocuments(files: any) {
    if (files && files.length) {
      updateShowError({ show: false, message: '' });
    }
    updateDocuments(files);
  }

  function randomUniqueId() {
    var uuid = Math.random()
      .toString(36)
      .slice(-8);
    return uuid;
  }

  async function uploadFilesToS3(file: any) {
    let key = getRandomStr(8) + '_' + file.name;
    const params = {
      Bucket: s3BucketName,
      Key: key,
      Body: file,
      ACL: 'private',
      ContentEncoding: 'base64',
    };
    const upload = s3.putObject(params);
    try {
      upload
        .on('httpUploadProgress', function(evt: any) {
          var uploaded = Math.round((evt.loaded / evt.total) * 100);
          updateUploadProgress(uploaded);
          var progressDiv: any = document.getElementById('myProgress');
          progressDiv.style.display = 'block';
          var progressBar: any = document.getElementById('myBar');
          progressBar.style.width = uploaded + '%';
          if (uploaded === 100) {
            afterUpload(uploaded);
          }
        })
        .send(function(err: any, data: any) {
          if (err) {
            updateErrorMessage(err && err.message ? err.message : err);
          } else {
            const d: any = {
              title: file.name,
              docKey: key,
              docUrl: s3ObjectUrl + `${key}`,
              docUniqueId: randomUniqueId(),
              notes: documentNotes,
              firebaseId: firebaseId,
              docContentType: file.type,
              documentType:
                documentType && documentType.value ? documentType.value : '',
              otherDocumentType: otherDocType,
              uploadedDate: moment().format('D MMM, YYYY hh:mm A'),
            };
            let uploadedFile: any = uploadedDocData;
            setTimeout(() => {
              if (isEdit && selectedFile && selectedFile.length) {
                if (uploadedDocData && uploadedDocData.length) {
                  uploadedFile = uploadedDocData.filter((f: any) => {
                    return f.docUniqueId !== selectedFile[0].docUniqueId;
                  });
                }
                setTimeout(() => {
                  getFiles(uploadedFile.concat([d]));
                  updateUploadedDocData(uploadedFile.concat([d]));
                }, 200);
                afterUpload(100);
              } else {
                getFiles(uploadedFile.concat([d]));
                updateUploadedDocData(uploadedFile.concat([d]));
              }
            }, 200);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function submitDocuments() {
    if (otherDocument && !otherDocType) {
      updateShowError({ show: true, message: 'Please enter document type' });
    } else if (
      (documents && !documents.length && !isEdit) ||
      (isEdit && selectedFile && !selectedFile.length)
    ) {
      updateShowError({
        show: true,
        message: 'Please select atleast one file',
      });
    } else {
      updateIsubmitted(true);
      updateUploadText('Uploading...');
      setTimeout(() => {
        if (documents && documents.length) {
          documents.map(async (file: any, key: number) => {
            uploadFilesToS3(file);
          });
          setTimeout(() => {
            updateDocuments([]);
          }, 1000);
        } else {
          if (isEdit && selectedFile && selectedFile.length) {
            let docFiles: any = uploadedDocData;
            if (docFiles && docFiles.length) {
              docFiles[index] = {
                ...selectedFile[0],
                otherDocumentType: otherDocType,
                documentType:
                  documentType && documentType.value ? documentType.value : '',
                notes: documentNotes,
              };
            }
            setTimeout(() => {
              getFiles(docFiles);
              updateUploadedDocData(docFiles);
            }, 200);
            afterUpload(100);
          }
        }
      }, 500);
    }
  }
  async function editDocuments(doc: UploadDocType, key: number) {
    updateIndex(key);
    updateSelectedFile([{ ...doc, name: doc.title, path: doc.title }]);
    updateDocumentNotes(doc ? doc.notes : '');
    setTimeout(() => {
      updateIsEdit(true);
      updateShowDocumentUpload(true);
      let option: SelectOption = defaultSelectOption;
      if (doc && doc.documentType) {
        option = {
          value: doc.documentType,
          label: doc.documentType,
        };
      }
      if (doc.documentType === 'Other') {
        updateOtherDocType(doc.otherDocumentType);
        updateOtherDocument(true);
      }
      setDocumentType(option);
    }, 100);
  }

  function onCancel() {
    updateShowDocumentUpload(false);
    setDocumentType(defaultSelectOption);
    updateSelectedFile(defaultSelectOption);
    updateDocumentNotes('');
    updateOtherDocument(false);
    updateOtherDocType('');
    updateIsEdit(false);
    updateShowError({ show: false, message: '' });
  }

  function uploadButton() {
    return (
      <Button
        variant={'warning'}
        disabled={!fromEditPage && !editTransactionPermission}
        onClick={() => updateShowDocumentUpload(true)}>
        Upload Document
      </Button>
    );
  }

  return (
    <>
      <DocumentHeader>
        <Title fromEditPage={fromEditPage}>Documents</Title>
        {uploadedDocData && uploadedDocData.length && !isApproved ? (
          <CustomButtonContainer>{uploadButton()}</CustomButtonContainer>
        ) : null}
      </DocumentHeader>
      {!fromEditPage && <Seperator />}
      {showDocumentUpload && (
        <Dialog
          customStyles={styles}
          title="Document Upload"
          onClose={() => onCancel()}
          showSeperator={true}>
          <SelectDocType>
            <SelectItem style={{ marginRight: '10px' }}>
              <SelectLabel>Document Type</SelectLabel>
              <Star>*</Star>
              <Select
                isCustom={true}
                options={documentTypes}
                placeholder="Type of Document"
                value={documentType}
                onChange={e => onChange(e, 'documentType')}
              />
            </SelectItem>
            {otherDocument && (
              <InputCard>
                <Label>Other Document</Label>
                <Star>*</Star>
                <Input
                  placeholder="Enter Document Type Here"
                  name="otherDocument"
                  value={otherDocType}
                  onChange={(e: any) => onChange(e, 'otherDoc')}
                />
              </InputCard>
            )}
          </SelectDocType>
          <DocumentsUpload
            disable={
              (documentType && !documentType.value) ||
              (otherDocument && !otherDocType)
                ? true
                : false
            }
            docType={documentType}
            updateFiles={setDocuments}
            uploadProgress={uploadProgress}
            isSubmitted={isSubmitted}
            uploadText={uploadText}
            selectedFile={selectedFile}
            showError={showError}
          />
          <NotesContainer>
            <TextArea
              label="Notes"
              size="80px"
              placeholder="Notes (any)"
              name="DocumentNotes"
              value={documentNotes}
              onChange={e => onChange(e, 'documentNotes')}
            />
          </NotesContainer>
          <UploadFooter>
            <CancelUpload>
              <Button
                onClick={() => onCancel()}
                backgroundColor={'#EFF3FA'}
                color="#483311"
                variant="other">
                Cancel
              </Button>
            </CancelUpload>
            <Button
              disabled={
                isSubmitted ||
                (documentType && !documentType.value) ||
                (otherDocument && !otherDocType)
              }
              onClick={() => submitDocuments()}
              backgroundColor={'#FFB900'}
              color="#483311"
              variant="other">
              Upload & Save
            </Button>
          </UploadFooter>
        </Dialog>
      )}
      {uploadedDocData && uploadedDocData.length ? (
        <UploadedDocuments
          uploadedDocData={uploadedDocData}
          editDocuments={editDocuments}
          allowEdit={isApproved ? false : true}
          afterRemove={removeDocument}
        />
      ) : (
        <NoDataContainer>
          <Icon name="documentIcon" />
          <p>No Documents uploaded.</p>
          {!isApproved && uploadButton()}
        </NoDataContainer>
      )}
    </>
  );
}
